module.exports = __webpack_public_path__ + "static/media/4ab86b35-c0c2-42b5-98ad-4b6eba66b197.594c5cdf.woff";